module.exports = __webpack_public_path__ + "media/components/signup/static/surf_image_1-6e8f92f95899ae040fa56ee20e26e8e2.webp";